.inputSearchContainer {
  width: min(100%, 600px);
  height: 52px;

  display: flex;
  align-items: center;
  gap: 14px;

  padding: 0 22px;
  box-sizing: border-box;

  background-color: #fff;
  border: 1px solid var(--color-unfocus-border);
  border-radius: 9px;
  box-shadow: 0 8px 24px rgba(20, 40, 90, 0.08);
  flex: 1;
}

.searchIcon {
  color: var(--color-primary);
}

.searchInput {
  flex: 1;
  width: 100%;

  border: none;
  outline: none;
  background: transparent;

  font-size: 0.95rem;
  font-family: var(--font-family-base);
  color: #27345f;
}

.searchInput::placeholder {
  color: #4c5f9e;
  font-style: normal;
}

.inputSearchContainer:focus-within {
  border-color: var(--color-focus-border);
  box-shadow: 0 8px 24px var(--color-box-shadow-subtle);
}